function getSector(catalogSector) {
  var result = [];
  catalogSector.forEach((elem) => {
    result.push({ key: elem.id, value: elem.name });
  });
  return result;
}

export default getSector;
